<mat-icon class="loading-spinner" svgIcon="rotating_icon"></mat-icon>
